import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { getLocalizedMessage } from './_helpers/Localization';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '612px',
    },
    griditem: {
        width: '100%',
        textAlign: 'center',
        padding: '10px',
    },
    errorImage: {
        width: "160px",
    }
}));

function Error(props) {
    const classes = useStyles();
    const { Language } = props;
    let Message;
    Message = getLocalizedMessage('systemerror', Language);

    let Caption = Message.Caption;

    return (
        <Grid key="container" container className={classes.root}>
            <Grid item className={classes.griditem}><img className={classes.errorImage} src='/error.png' alt="An unexpected error occured. Please try again" /></Grid>
            <Grid item className={classes.griditem}><Typography key={'Caption'}>{Caption}</Typography></Grid>
        </Grid>
    );
}

export default Error;